import React from 'react';
import './Syles/Communication.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import StyledContent from '../../Shared/StyledTitle/StyledTitle';
import { AiOutlineClose } from 'react-icons/ai';
import Styledlink from '../../Shared/StyledLink/StyledLink';
import Team from '../../Shared/Team/Team';
const Communication=()=>{
    return(
        <div className="communication-home">
            <div className="image-part">
            <div className="share" data-aos="zoom-in"
              data-aos-delay={200}>
                <h2>Share Link</h2>
                <div className="inputpart">
                    <p>Link</p>
                    <h3>https://my.hostdesign.com/publinmk /show?code-ASSDasa34fsddfs3f</h3>
                </div>
                <div className="inputpart">
                    <p>Send Link to</p>
                    <div className="input-group">
                            <div className="checked">
                                <p>testproject@gmail.com</p>
                                <AiOutlineClose className="icon"/>
                            </div>
                            <input type="text" placeholder="Add more people..."/>
                        </div>
                </div>
                <textarea cols={9} rows={3} >
                    Add a note
                </textarea>
            </div>
            </div>
            <div className="content">
                <StyledContent 
                title="Communication is key"
                desc="You can ask colleagues and clients for feedback by giving them a private link, or inviting them via email. We don’t restrict the number of collaborators you can have, so you’re free to get everyone involved."
                />
                 <StyledButton btn="Learn More" styles="nobg-btn"/>
                 <Team />
            </div>
        </div>
    )
};
export default Communication ;